import helpers from '.'

const mountUserHeader = (user) => [
  [user?.name, helpers.userCertificationStatus(user)],
]

export default mountUserHeader
